import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import AddBannerForm from './components/AddBannerForm';

const AddBanner = () => (
    <Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">Banner Status</h3>
                <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/banner-status">Banner Status</Link> / Add Banner</h3>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody style={{ display: 'flex' }}>
                        <AddBannerForm />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
);

export default AddBanner;
